import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    accordions: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        paddingX: theme.spacing(2),
        borderRadius: '4px',
    },
    button: {
        padding: '0.3rem 1rem',
        fontSize: '12px',
        marginRight: '10px',
        whiteSpace: 'nowrap',
    },
    textBox: {
        width: 200,
    },
}));

export default useStyles;
